import { Injectable } from '@angular/core';
import { NgxsOnChanges, NgxsSimpleChange, State } from '@ngxs/store';
import { ShippingProfileModel } from 'src/app/_models/shipping-profile.model';
import { ShippingProfilesService } from 'src/app/_services/shipping-profiles.service';
import { DataAction, StateRepository } from '@angular-ru/ngxs/decorators';
import { createEntityCollections, EntityIdType } from '@angular-ru/cdk/entity';
import { NgxsDataEntityCollectionsRepository } from '@angular-ru/ngxs/repositories';
import BaseEntityCollectionsOptions from '../../base-entity-collections-options';

@StateRepository()
@State({
    name: 'shippingRulesState',
    defaults: {
        ...createEntityCollections(),
        loading: false
    }
})
@Injectable()
export default class ShippingProfilesEntitiesState
    extends NgxsDataEntityCollectionsRepository<ShippingProfileModel, EntityIdType, BaseEntityCollectionsOptions>
    implements NgxsOnChanges {

    private _ngxsOnChange = (state?: ShippingProfilesEntitiesState) => { };
    private _changeObserver: typeof this.state$;

    constructor(
        private shippingRulesService: ShippingProfilesService
    ) {
        super();
    }

    ngxsOnChanges(_?: NgxsSimpleChange) {
        super.ngxsOnChanges(_);
        if (this.isInitialised && !this._changeObserver) {
            this._changeObserver = this.state$;
            this._changeObserver.subscribe(() => this._ngxsOnChange());
        }
    }

    // Actions
    @DataAction()
    public setDefaultProfile(profileId: number) {
        this.shippingRulesService.setAsDefault(profileId).subscribe(result => {
            const profiles = this.entitiesArray.map(profile => ({ ...profile, default: profile.id === profileId }));
            this.upsertEntitiesMany(profiles);
        });
    }

    // Actions
    @DataAction()
    public load() {
        this.patchState({ loading: true });
        this.shippingRulesService.fetch()
            .subscribe((result: ShippingProfileModel[]) => {
                this.setEntitiesAll(result);
                this.patchState({ loading: false, loaded: true });
            });
    }

    @DataAction()
    lazyLoad() {
        !this.snapshot.loading &&
            !this.snapshot.loaded &&
            this.load();
    }

    public onStateChange(callback: typeof this._ngxsOnChange) {
        this._ngxsOnChange = callback;
    }
}
